var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54833 6.45117L3.42417 10.5753",
    stroke: "#667085",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86925 7.5826L1.84917 7.10543C1.62692 7.05293 1.54875 6.77702 1.70975 6.61543L3.31625 5.00893C3.42417 4.90102 3.57058 4.83918 3.724 4.83802L5.53525 4.82227",
    stroke: "#667085",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5961 5.23577L12.0674 2.96777C12.1958 2.3506 11.6498 1.8046 11.0326 1.93294L8.76459 2.40427C8.09667 2.5431 7.48417 2.87385 7.00234 3.35627L5.1415 5.21652C4.43159 5.92644 3.96959 6.84694 3.82375 7.84035L3.81734 7.88294C3.72517 8.51702 3.9375 9.15694 4.39017 9.61019V9.61019C4.84284 10.0629 5.48334 10.2752 6.11742 10.1824L6.16 10.176C7.15342 10.0308 8.07392 9.56819 8.78384 8.85827L10.6441 6.99802C11.1265 6.51619 11.4573 5.90369 11.5961 5.23577V5.23577Z",
    stroke: "#667085",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.81667 2.75C9.16475 3.66933 10.3308 4.83542 11.2502 6.1835",
    stroke: "#667085",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.41667 10.1308L6.89383 12.1509C6.94633 12.3732 7.22225 12.4513 7.38383 12.2903L8.99033 10.6838C9.09825 10.5759 9.16008 10.4295 9.16125 10.2761L9.177 8.46484",
    stroke: "#667085",
    strokeWidth: 0.875,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/Rocket.46edfe43c8e7faf2b493db5ebb935a5e.svg";
export { ForwardRef as ReactComponent };